import { ApiAreaOfFocus } from 'api/types/ApiAreaOfFocus';
import { getJson } from 'utils/http';

export function apiFetchAreasOfFocus(): Promise<ApiAreaOfFocus[]> {
  return getJson(`/data/website/areas-of-focus?lang=${CURRENT_LOCALE}`).then(
    // @ts-expect-error TS(2345): Argument of type '({ areasOfFocus }: { areasOfFocu... Remove this comment to see the full error message
    ({ areasOfFocus }) => areasOfFocus,
  );
}
